/**
 * Banner with Dropdown Button JavaScript
 * Handles dropdown navigation and animations
 */

// Dropdown Navigation Functionality
document.addEventListener('DOMContentLoaded', function() {
	// Dropdown functionality
	const dropdownButtons = document.querySelectorAll('.dropdown-button');
	
	dropdownButtons.forEach(button => {
		const buttonId = button.id;
		const contentId = buttonId.replace('btn', 'content');
		const dropdownContent = document.getElementById(contentId);
		
		button.addEventListener('click', function(e) {
			e.preventDefault();
			
			// Close all other dropdowns
			document.querySelectorAll('.dropdown-content.active').forEach(content => {
				if (content.id !== contentId) {
					content.classList.remove('active');
					const otherButtonId = content.id.replace('content', 'btn');
					document.getElementById(otherButtonId).classList.remove('active');
				}
			});
			
			// Toggle current dropdown
			dropdownContent.classList.toggle('active');
			button.classList.toggle('active');
		});
	});
	
	// Navigation functionality
	const dropdownItems = document.querySelectorAll('.dropdown-item');
	
	dropdownItems.forEach(item => {
		item.addEventListener('click', function(e) {
			e.preventDefault();
			
			const targetId = this.getAttribute('data-target');
			if (targetId) {
				const targetElement = document.getElementById(targetId);
				if (targetElement) {
					// Smooth scroll to target
					targetElement.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
					
					// Close dropdown after navigation
					const dropdown = this.closest('.dropdown-content');
					const button = dropdown.previousElementSibling;
					dropdown.classList.remove('active');
					button.classList.remove('active');
				}
			}
		});
	});
	
	// Close dropdown when clicking outside
	document.addEventListener('click', function(e) {
		if (!e.target.closest('.dropdown-navigation')) {
			document.querySelectorAll('.dropdown-content.active').forEach(content => {
				content.classList.remove('active');
				const buttonId = content.id.replace('content', 'btn');
				document.getElementById(buttonId).classList.remove('active');
			});
		}
	});
});

/**
 * Banner with Dropdown Button Custom Element
 * Handles animations and parallax effects
 */
if (!customElements.get('banner-with-dropdown-button')) {
  class BannerWithDropdownButton extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
    }

    connectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }
    }

    disconnectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.tl.kill();
        this.splittext.revert();
      }
    }

    prepareAnimations() {
      let section = this,
        button_offset = 0,
        property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top center"
        }
      });

      document.fonts.ready.then(function () {
        section.splittext = new SplitText(section.querySelectorAll('.banner-with-dropdown-button--heading, p:not(.subheading)'), {
          type: 'lines, words',
          linesClass: 'line-child'
        });

        if (section.querySelector('.subheading')) {
          section.tl
            .fromTo(section.querySelector('.subheading'), {
              opacity: 0
            }, {
              duration: 0.75,
              opacity: 0.6
            }, 0);

          button_offset += 0.5;
        }
        
        if (section.querySelector('.banner-with-dropdown-button--heading')) {
          let h3_duration = 0.8 + ((section.querySelectorAll('.banner-with-dropdown-button--heading .line-child div').length - 1) * 0.08);
          section.tl
            .set(section.querySelector('.banner-with-dropdown-button--heading'), {
              visibility: 'visible'
            }, 0)
            .from(section.querySelectorAll('.banner-with-dropdown-button--heading .line-child div'), {
              duration: h3_duration,
              yPercent: '100',
              stagger: 0.08
            }, 0);
          button_offset += h3_duration;
        }
        
        if (section.querySelector('.rte p')) {
          let p_duration = 0.8 + ((section.querySelectorAll('.rte p .line-child div').length - 1) * 0.02);
          section.tl
            .set(section.querySelectorAll('.rte p'), {
              visibility: 'visible'
            }, 0)
            .from(section.querySelectorAll('.rte p .line-child div'), {
              duration: p_duration,
              yPercent: '100',
              stagger: 0.02
            }, 0);
          button_offset += p_duration;
        }
        
        if (section.querySelectorAll('.button')) {
          let i = 1;
          section.querySelectorAll('.button').forEach((item) => {
            section.tl.fromTo(item, {
              autoAlpha: 0
            }, {
              duration: 0.5,
              autoAlpha: 1
            }, ((button_offset * 0.4) + (i - 1) * 0.1));
            i++;
          });
        }

        // Animate dropdown navigation
        if (section.querySelector('.dropdown-navigation')) {
          section.tl.fromTo(section.querySelector('.dropdown-navigation'), {
            autoAlpha: 0,
            y: 20
          }, {
            duration: 0.6,
            autoAlpha: 1,
            y: 0
          }, button_offset * 0.4);
        }
      });

      // Parallax effect for background images
      if (section.querySelector('.thb-parallax-image')) {
        gsap.fromTo(section.querySelectorAll('.thb-parallax-image'), {
          y: '-8%'
        }, {
          y: '8%',
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            scrub: 1,
            start: () => `top bottom`,
            end: () => `bottom top+=${property}`,
            onUpdate: () => {
              property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';
            }
          }
        });
      }
    }
  }
  
  customElements.define('banner-with-dropdown-button', BannerWithDropdownButton);
}